import { NgComponentOutlet } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import type { PushNotificationsTwaComponent } from '@bcf-v2-ui-legacy-others-components-sportsbook-lvbetpl/mobile-web/push-notifications/push-notifications-twa.component';
import type { AppCombinedWithBpMaintenanceService } from '@bcf-v2-ui-shared/services/app-combined-with-bp-maintenance.service';
import { AppLoadedService } from '@bcf-v2-ui-shared/services/app-loaded.service';
import { maintenanceRoutePath } from '@bcf-v2/routes/common/app/paths/maintenance-route-path';
import { Unsubscribable } from '@bcf2-shared-pkg-v1/platforms/platform-worker/browser/unsubscribable';
@Component({
  standalone: true,
  selector: 'bcf-root',
  imports: [RouterOutlet, NgComponentOutlet],
  templateUrl: './app.component.html'
})
export class AppComponent extends Unsubscribable implements OnInit {
  public pushNotificationsTwaComponent: typeof PushNotificationsTwaComponent | undefined;

  constructor(
    private _router: Router,
    private _injector: Injector,
    private _appLoadedService: AppLoadedService
  ) {
    super();
  }

  public ngOnInit(): void {
    this._initApp();
    this._initPushNotifications();
    this._initAppMaintenance();
    this._initLogRocket();
    this._appLoadedService.init();
    this._initAppDestroy();
  }

  private async _initApp(): Promise<void> {
    this._injector
      .get(
        (
          await import(
            /* webpackChunkName: "app-initializator" */ '@apps/projects/sportsbook/lvbetpl/mobile-web/src/app/app-initializator'
          )
        ).LazyInitializatorSbLvbetplMobileWeb
      )
      .init();
  }

  private async _initPushNotifications(): Promise<void> {
    this.pushNotificationsTwaComponent = await import(
      /* webpackChunkName: "push-notifications-initializer" */ '@bcf-v2-ui-legacy-others-components-sportsbook-lvbetpl/mobile-web/push-notifications/push-notifications-twa.component'
      // eslint-disable-next-line @typescript-eslint/typedef
    ).then((mod) => mod.PushNotificationsTwaComponent);
  }

  private async _initAppMaintenance(): Promise<void> {
    const instance: AppCombinedWithBpMaintenanceService = this._injector.get(
      (
        await import(
          /* webpackChunkName: "app-maintenance" */ '@bcf-v2-ui-shared/services/app-combined-with-bp-maintenance.service'
        )
      ).AppCombinedWithBpMaintenanceService
    );
    this._sub = instance.doRedirectToMaintenance().subscribe(() => this._router.navigate([maintenanceRoutePath()]));
  }

  private async _initLogRocket(): Promise<void> {
    this._injector
      .get(
        (
          await import(
            /* webpackChunkName: "log-rocket" */ '@bcf-v2-ui-utilities/analytics/log-rocket-initializer.service'
          )
        ).LogRocketInitializerService
      )
      .init();
  }

  private async _initAppDestroy(): Promise<void> {
    this._injector
      .get(
        (await import(/* webpackChunkName: "app-destroy" */ '@bcf-v2-ui-shared/services/app-destroy.service'))
          .AppDestroyService
      )
      .init();
  }
}
